import { colors, Components, Theme } from '@mui/material';

const muiChip: Components<Theme>['MuiChip'] = {
	defaultProps: {
		size: 'small',
		sx: {
			paddingX: 1,
		},
	},
	styleOverrides: {
		root: {
			backgroundColor: colors.blueGrey[50],
			color: colors.blueGrey[900],
		},
		label: ({ theme }) => ({
			fontSize: theme.typography.label.fontSize,
			fontWeight: theme.typography.label.fontWeight,
		}),
		sizeSmall: {
			height: '20px',
		},
		colorPrimary: ({ theme }) => ({
			// Align color pattern. Not use the disabled color scheme for this
			backgroundColor: theme.palette.disabled.light,
			color: theme.palette.disabled.main,
		}),
		colorSuccess: ({ theme }) => ({
			backgroundColor: theme.palette.success.light,
			color: theme.palette.success.main,
		}),
		colorInfo: ({ theme }) => ({
			backgroundColor: theme.palette.info.light,
			color: theme.palette.info.main,
		}),
		colorError: ({ theme }) => ({
			backgroundColor: theme.palette.error.light,
			color: theme.palette.error.main,
		}),
		colorWarning: ({ theme }) => ({
			backgroundColor: theme.palette.warning.light,
			color: theme.palette.warning.main,
		}),

		deletable: {
			'&:focus': {
				backgroundColor: colors.blueGrey[100],
			},
		},
	},
};
export default muiChip;
